/**
 * Menu item
 */
export class MenuItem {
    /**
     * Menu item name
     */
    public name: string;

    /**
     * Link for menu item
     */
    public link: string;

    /**
     * Menu divider
     */
    public divider: boolean;

    /**
     * Hover state on menu item
     */
    public hover: boolean;

    /**
     * Bold style on menu item label
     */
    public active: boolean;

    /**
     * Style class on menu item (used on right part of menu)
     */
    public styleClass: string;

    /**
     * List of sub items
     */
    public subItems: MenuItem[];

    /**
     * If external true, link would open in new tab
     */
    public external: boolean;

    /**
     * The "constructor"
     */
    constructor(fields?: {
        name?: string,
        link?: string,
        type?: string, // username, logout
        divider?: boolean,
        hover?: boolean,
        active?: boolean,
        styleClass?: string,
        subItems ?: MenuItem[],
        external?: boolean;
    }) {
        if (fields) {
            (Object as any).assign(this, fields);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/menu/menuitem.ts